<template>
  <div class="trade-order-block">
    <div class="block-title">门店执行信息</div>
    <div class="block-title block-sub-title">资产冰柜</div>
    <div class="block-content">
      <el-row class="content-row cooler-row" v-viewer="{ movable: true }">
        <div
          class="cooler-list"
          v-for="(
            cooler, index
          ) in tradeApplyExecCooler.tradeApplyExecCoolerList"
          :key="index"
        >
          <div class="cooler-item">
            <div class="item-img cooler-img">
              <img :src="getCoolerImg(cooler)" />
            </div>
            <div class="cooler-img-title">
              {{ cooler.coolerName }}
            </div>
            <div
              v-if="cooler.pledgePayTime"
              style="padding-top: 6px; color: #666; font-size: 12px"
            >
              付款时间:{{
                cooler.pledgePayTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}')
              }}
            </div>
          </div>
          <div class="cooler-position">
            <div class="item-img">
              <img :src="getImg(cooler.positionPhotoUri)" />
            </div>
            <div class="cooler-img-title">摆放位置照片</div>
          </div>
        </div>
      </el-row>
      <el-row class="content-row">
        <BaseCell :value="tradeApplyInfoVO.clientTypeName" label="业务线" />
      </el-row>
      <el-row class="content-row">
        <BaseCell
          :value="tradeApplyExecVO.paidContactPerson"
          label="押金支付人姓名"
        />
        <BaseCell
          :value="tradeApplyBaseVO.keyContactPerson"
          label="收货人姓名"
        />
      </el-row>

      <el-row class="content-row">
        <BaseCell
          :value="tradeApplyExecVO.paidContactPhone"
          label="押金支付人手机号"
        />
        <BaseCell
          :value="tradeApplyBaseVO.keyContactPhone"
          label="收货人电话"
        />
      </el-row>
      <el-row class="content-row purpose">
        
        <BaseCell
          :value="tradeApplyExecCooler.upstairsFlag ? '是' : '否'"
          label="是否需要搬运上楼"
        />
        <BaseCell
          :value="tradeApplyExecVO.investLevelName"
          isTooltip
          :tooltipContent="tradeApplyExecVO.investLevelDesc"
          label="投入目的"
        >
        </BaseCell>
      </el-row>
      <el-row class="content-row">
        <BaseCell
          :value="tradeApplyInfoVO.salesContactPerson"
          label="业务员姓名"
        />
      </el-row>
      <el-row class="content-row">
        <BaseCell
          :value="tradeApplyInfoVO.salesContactPhone"
          label="业务员电话"
        />
      </el-row>

      <el-row class="content-row">
        <el-col :span="3">其它照片</el-col>
        <el-col :span="21" v-viewer="{ movable: true }" class="info-img">
          <div
            v-if="
              tradeApplyInfoVO.extraPhotoList &&
              tradeApplyInfoVO.extraPhotoList.length
            "
          >
            <div
              class="img-wrapper"
              v-for="img in tradeApplyInfoVO.extraPhotoList"
              :key="img.title"
            >
              <img :src="getImg(img.imageUri)" />
            </div>
          </div>
          <div v-else>暂无</div>
        </el-col>
      </el-row>
      <el-row class="content-row">
        <BaseCell
          :value="tradeApplyInfoVO.applyDesc"
          label="提报说明"
          allCell
        />
      </el-row>
    </div>
  </div>
</template>

<script>
import BaseCell from '@/components/base-cell'
import { commonUtils } from '@/utils/common'
export default {
  name: 'order-exec-cooler',
  components: {
    BaseCell
  },
  props: {
    tradeApplyExecVO: {
      type: Object,
      default: () => {}
    },
    tradeApplyBaseVO: {
      type: Object,
      default: () => {}
    },
    tradeApplyInfoVO: {
      type: Object,
      default: () => {}
    },
    tradeApplyExecCooler: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    getCoolerImg(cooler) {
      if (cooler.itemImageList?.length) {
        if (typeof cooler.itemImageList[0] === 'string') {
          return this.getImg(cooler.itemImageList[0])
        } else {
          return this.getImg(cooler.itemImageList[0].imageFileUri)
        }
      } else {
        return ''
      }
    },

    getImg(uri) {
      return commonUtils.getImageUrl(uri)
    }
  }
}
</script>

<style lang="scss" scoped>
.cooler-row {
  display: flex;
  flex-wrap: wrap;
  .cooler-list {
    display: flex;
    border-right: 2px dotted #999;
    padding: 0 15px;
    margin-bottom: 15px;

    .item-img {
      border: 2px solid #e6e6e6;
      border-radius: 8px;
      box-sizing: border-box;
      text-align: center;
      margin: 0 5px;
      img {
        width: 110px;
        height: 110px;
        object-fit: cover;
        border-radius: 8px;
        cursor: pointer;
      }
    }

    .cooler-img {
      img {
        object-fit: contain;
      }
    }
    &:last-child {
      border-right: none;
    }
  }

  .cooler-img-title {
    text-align: center;
    font-size: 13px;
    color: #666;
    margin-top: 8px;
  }
}
</style>
